import React from 'react';

const Pagination = ({ currentPage, totalPages, setCurrentPage }) => {
    // Generate page numbers
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 4) {
                for (let i = 1; i <= 5; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 3) {
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push('...');
                pages.push(currentPage - 1);
                pages.push(currentPage);
                pages.push(currentPage + 1);
                pages.push('...');
                pages.push(totalPages);
            }
        }
        return pages;
    };

    return (
        <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
            <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                    padding: '0.4rem 0.8rem',
                    borderRadius: '4px',
                    border: '1px solid #e2e8f0',
                    backgroundColor: currentPage === 1 ? '#f8fafc' : 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    color: currentPage === 1 ? '#94a3b8' : 'inherit',
                    fontSize: '0.875rem'
                }}
            >
                Previous
            </button>
            
            {getPageNumbers().map((page, index) => (
                <React.Fragment key={index}>
                    {page === '...' ? (
                        <span style={{ padding: '0.4rem 0.5rem', color: '#94a3b8' }}>...</span>
                    ) : (
                        <button
                            onClick={() => setCurrentPage(page)}
                            style={{
                                padding: '0.4rem 0.8rem',
                                borderRadius: '4px',
                                border: page === currentPage ? '1px solid var(--primary)' : '1px solid #e2e8f0',
                                backgroundColor: page === currentPage ? 'var(--primary)' : 'white',
                                color: page === currentPage ? 'white' : 'inherit',
                                cursor: 'pointer',
                                fontSize: '0.875rem'
                            }}
                        >
                            {page}
                        </button>
                    )}
                </React.Fragment>
            ))}

            <button
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages || totalPages === 0}
                style={{
                    padding: '0.4rem 0.8rem',
                    borderRadius: '4px',
                    border: '1px solid #e2e8f0',
                    backgroundColor: currentPage === totalPages || totalPages === 0 ? '#f8fafc' : 'white',
                    cursor: currentPage === totalPages || totalPages === 0 ? 'not-allowed' : 'pointer',
                    color: currentPage === totalPages || totalPages === 0 ? '#94a3b8' : 'inherit',
                    fontSize: '0.875rem'
                }}
            >
                Next
            </button>
        </div>
    );
};

export default Pagination;
